import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { formatEventTime } from "@notemeal/utils-date-time";
import classnames from "classnames";
export const useActivityItemContainerStyles = makeStyles(({ palette: { accents: { orangeDark }, }, }) => ({
    activityItemContainer: {
        backgroundColor: orangeDark[100],
        padding: 10,
        margin: 10,
    },
    exported: {
        backgroundColor: orangeDark[100],
        height: `20px`,
        marginTop: `5px`,
        marginBottom: `5px`,
        padding: `2px`,
    },
    dense: {
        backgroundColor: orangeDark[100],
        padding: 0,
        margin: 3,
        textAlign: "center",
    },
}));
export const ActivityItemContainer = ({ children, className, sx }) => {
    const classes = useActivityItemContainerStyles();
    return (_jsx(Paper, { sx: sx, className: classnames(classes.activityItemContainer, className), children: children }));
};
export const ActivityItem = ({ activity, className }) => {
    const classes = useActivityItemContainerStyles();
    return (_jsx(ActivityItemContainer, { className: classnames(classes.activityItemContainer, className), children: _jsxs(Typography, { align: "center", variant: "body1Medium", children: [activity.name, " (", formatEventTime(activity), ")"] }) }));
};
export const ExportActivityItem = ({ activity, className }) => {
    const classes = useActivityItemContainerStyles();
    return (_jsx(ActivityItemContainer, { className: classnames(classes.exported, className), children: _jsxs(Typography, { align: "center", variant: "body2", children: [activity.name, " (", formatEventTime(activity), ")"] }) }));
};
export const DenseActivityItem = ({ activity }) => {
    const classes = useActivityItemContainerStyles();
    return (_jsx(ActivityItemContainer, { className: classes.dense, children: _jsxs(Typography, { align: "center", variant: "subtitle1", children: [activity.name, " (", formatEventTime(activity), ")"] }) }));
};
//# sourceMappingURL=index.js.map